import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Instruments from "./pages/Instruments";
import CustomBuilds from "./pages/CustomBuilds";
import About from "./pages/About";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ProtectedAdmin({ children }) {
  const token =
    typeof window !== "undefined" ? localStorage.getItem("wbz_admin_token") : null;
  if (!token) {
    window.location.replace("/admin/login");
    return null;
  }
  return children;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const hideChrome = pathname.startsWith("/admin");
  return (
    <>
      {!hideChrome && <Navbar />}
      {children}
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0c0a09",
              border: "1px solid #44403c",
              color: "#fafaf9",
              borderRadius: 0,
            },
          }}
        />
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:slug" element={<ProductDetail />} />
            <Route path="/instruments" element={<Instruments />} />
            <Route path="/custom" element={<CustomBuilds />} />
            <Route path="/about" element={<About />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedAdmin>
                  <AdminDashboard />
                </ProtectedAdmin>
              }
            />
          </Routes>
        </Shell>
      </BrowserRouter>
    </div>
  );
}

export default App;
